import cxs from 'cxs';
import { MEDIA_QUERIES } from '../../../common/styles/vars';

const LAST_DATE_PICKER_SELECTOR = ' > .date-picker:last-of-type:not(:only-of-type)';
const LAST_LABEL_SELECTOR = ' > label:last-of-type:not(:only-of-type)';

const MOBILE_MARGIN = {
  marginLeft: '0',
  marginTop: '15px'
};

export default cxs({
  display: 'flex',
  alignItems: 'center',
  width: '100%',

  ' > .date-picker': {
    width: '100%'
  },

  [LAST_DATE_PICKER_SELECTOR]: {
    marginLeft: '15px'
  },

  [LAST_LABEL_SELECTOR]: {
    marginLeft: '15px'
  },

  [MEDIA_QUERIES.small]: {
    flexDirection: 'column',

    [LAST_DATE_PICKER_SELECTOR]: MOBILE_MARGIN,
    [LAST_LABEL_SELECTOR]: MOBILE_MARGIN
  }
});